import { Contact } from './contact';
import { UserCapabilities } from './userCapabilities';

export enum UserRoleEnum {
  CLIENT = 'CLIENT',
  CLIENT_CRM = 'CLIENT_CRM'
}

export type UserRole = UserRoleEnum;

export interface UserProfile {
  role: UserRoleEnum;
  person: Contact;
  capabilities: UserCapabilities;
  // if client user, contacts has 1 element (the crm), if crm user, contacts has all clients of the crm user
  contacts: Contact[];
}
